<!-- Селект типа действия для фильтрации журнала событий. Список загружается с бэкенда -->
<template>
  <BaseSelect
    :options="store.availableActions"
    :model-value="modelValue"
    placeholder="Все действия"
    :clearable="true"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
import { useActivityLogStore } from "@/stores/activityLogStore";

export default {
  name: "ActivityLogActionSelect",

  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },

  emits: ["update:modelValue"],

  computed: {
    store() {
      return useActivityLogStore();
    },
  },
};
</script>
